import { SvgIcon } from '@mui/material';

const IconDetails = (props) => {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
      <path d="M5.625 8.125H12.5V9.375H5.625V8.125ZM5.625 11.25H10V12.5H5.625V11.25Z" />
      <path d="M16.25 18.75H3.75C3.41858 18.7497 3.10083 18.6179 2.86648 18.3835C2.63213 18.1492 2.50033 17.8314 2.5 17.5V2.5C2.50033 2.16858 2.63213 1.85083 2.86648 1.61648C3.10083 1.38213 3.41858 1.25033 3.75 1.25H16.25C16.5814 1.25033 16.8992 1.38213 17.1335 1.61648C17.3679 1.85083 17.4997 2.16858 17.5 2.5V17.5C17.4997 17.8314 17.3679 18.1492 17.1335 18.3835C16.8992 18.6179 16.5814 18.7497 16.25 18.75ZM3.75 2.5V17.5H16.25V2.5H3.75Z" />
    </SvgIcon>
  );
};

export default IconDetails;
